import React from 'react'
import PropTypes from 'prop-types'

export class ImageWithFallback extends React.PureComponent {
  static propTypes = {
    src: PropTypes.string,
    srcHighlight: PropTypes.string,
    fallback: PropTypes.string,
    className: PropTypes.string,
    alt: PropTypes.string,
    style: PropTypes.object
  }

  state = {
    error: false,
    hover: false
  }

  render() {
    const {
      src: originalSrc,
      srcHighlight,
      fallback,
      className,
      alt,
      style = {}
    } = this.props
    const { error, hover } = this.state
    const src = error
      ? fallback
      : hover
      ? srcHighlight || originalSrc
      : originalSrc
    return (
      <img
        src={src}
        className={className}
        alt={alt}
        style={style}
        onError={() => {
          this.setState({ error: true })
        }}
        onMouseEnter={() => {
          this.setState({ hover: true })
        }}
        onMouseLeave={() => {
          this.setState({ hover: false })
        }}
      />
    )
  }
}
